import { render, staticRenderFns } from "./vue-navigation.vue?vue&type=template&id=4ba2077a&scoped=true&"
import script from "./vue-navigation.vue?vue&type=script&lang=js&"
export * from "./vue-navigation.vue?vue&type=script&lang=js&"
import style0 from "./vue-navigation.vue?vue&type=style&index=0&id=4ba2077a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba2077a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VListGroup } from 'vuetify/lib/components/VList';
installComponents(component, {VListGroup})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import Ripple from 'vuetify/lib/directives/ripple'
installDirectives(component, {Ripple})
